import React from 'react'
import './index.less'
export default function index(props) {
    return (
        <div className='shuqin-title' style={{marginBottom: props.bottom || 40}}>
            <h2>{props.title}</h2>
            {props.subTitle ? <p>{props.subTitle}</p> : null}
        </div>
    )
}
